<template>
    <div class="login_container" :style="container">
        <div id="fujia" style="position: absolute; height: 60px;line-height: 60px;right:20px;">
            <a href="http://www.zhuineng.com" target="_blank" style="color: #6ca9dd;font-size: 20px;text-decoration:none">商用设备系统</a>
        </div>
        <div class="shang" :style="objstyle">
            <img src="../assets/login/1561.png">
            <div class="you"></div>
            <!--img src="../assets/login/未标题-1@2x.png"-->
        </div>
        <div class="login_box" :style="loginstyle">
            <div class="title">
                <!--<span >嘉小二 · 舒适生活好管家</span>-->
                <img src="../assets/login/logo4.png" alt="" style="height: 40px;">
            </div>
            <!--头像区域-->
            <div class="left" v-if="leftshow">
                <img src="../assets/login/未标题-2@2x.png" alt="" style="height: 70%">
                <div id="hot-title">物联热暖系统</div>
                <img id="hot-line" src="../assets/login/hot-line2.png">
                <img id="hot" src="../assets/login/hot2.png">
                <div id="water-title">物联净软水系统</div>
                <img id="water-line" src="../assets/login/water-line2.png">
                <img id="water" src="../assets/login/water2.png">
                <div id="wind-title">物联新风系统</div>
                <img id="wind-line" src="../assets/login/wind-line2.png">
                <img id="wind" src="../assets/login/wind2.png">
                <div id="ai-title">智能家居安防系统</div>
                <img id="ai-line" src="../assets/login/ai-line2.png">
                <img id="ai" src="../assets/login/ai2.png">
                <el-row :gutter="5" class="left-bot">
                    <el-col :sm="4" :md="4" v-for="(item,i) in tubiao" :key="i">
                        <div class="">
                            <!--i :class="'iconfont '  +item.icon"></i-->
                            <img :src="require('../assets/login/' + item.icon + '.png')" alt="" style="width: 40px;height: 40px;" class="raise">
                        </div>
                        <div class=""><span>{{item.name}}</span></div>
                    </el-col>
                </el-row>
            </div>
            <!--登录表单区域-->
            <el-form ref="loginFormRef" :rules="loginFormRules" :model="loginForm" label-width="80px" label-position="left" class="login_form" :style="loginFormStyle">
                <el-row>
                    <el-col :span="6" class="bottomline textfont">
                        <!--<el-form-item label="用户登录" class="bottomline textfont ">
                        </el-form-item>-->
                        <span class=" shouxing" @click="setUsername" v-if="loginForm.type==='username'" style="font-size: 20px;line-height: 60px;color: #E7BC13;padding: 0 12px 0 0;">用户登录
                        </span>
                        <span class=" shouxing" @click="setUsername" v-else style="font-size: 20px;line-height: 60px;color: #999999;padding: 0 12px 0 0;">用户登录
                        </span>
                    </el-col>
                    <el-col :span="18" class="bottomline textfont">
                        <span class=" shouxing" @click="setMobile" v-if="loginForm.type!='username'" style="font-size: 20px;line-height: 60px;color: #E7BC13;padding: 0 12px 0 0;">手机登录
                        </span>
                        <span class=" shouxing" @click="setMobile" v-else style="font-size: 20px;line-height: 60px;color: #999999;padding: 0 12px 0 0;">手机登录
                        </span>
                    </el-col>
                </el-row>
                <!--用户名-->
                <el-row v-if="loginForm.type==='username'">
                    <el-form-item prop="userName" label="账号" class="bottomline">
                        <el-input v-model="loginForm.userName" placeholder="请输入账号" class="bordernone"></el-input>
                    </el-form-item>
                </el-row>

                <!--手机号-->
                <el-row v-if="loginForm.type==='mobile'||loginForm.type==='code'">
                    <el-form-item prop="mobile" label="手机号" class="bottomline" >
                        <el-input v-model="loginForm.mobile" placeholder="请输入手机号" class="bordernone"></el-input>
                    </el-form-item>
                </el-row>

                <!--密码-->
                <el-row v-if="loginForm.type==='mobile'||loginForm.type==='username'">
                    <el-form-item prop="password" label="密码" class="bottomline" v-if="loginForm.type==='mobile'||loginForm.type==='username'">
                        <el-input :type="passwordVisible" v-model="loginForm.password" placeholder="请输入登录密码" class="bordernone" >
                            <i slot="suffix" class="iconfont iconbukejian1 shouxing" @click="showhide()" :style="{ color: this.eyecolor }"></i>
                        </el-input>
                    </el-form-item>
                </el-row>

                <el-row v-if="loginForm.type==='code'">
                    <el-col :span="17">
                        <el-form-item prop="code" label="验证码" class="bottomline" >
                            <el-input v-model="loginForm.code" placeholder="请输入验证码" class="bordernone" ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" :offset="1" >
                        <el-button type="primary" @click="getCode('login')" size="small" :disabled="this.yanzheng.yzmSeconds<60">{{ yanzheng.yzmButtonText }}</el-button>
                    </el-col>
                </el-row>
                <el-form-item class="mima">
                    <el-checkbox v-model="loginForm.checked">记住登录密码</el-checkbox>
                    <a @click="forgetdialogVisible=true" class="shouxing">忘记密码?</a>
                </el-form-item>
                <!--按钮-->
                <el-form-item class="btns">
                    <el-button class="denglu" :loading="loading" @click="login">登录</el-button>
                    <!--el-button type="info" @click="resetLoginForm">重置</el-button-->
                </el-form-item>
                <el-form-item class="zhuce">
                    <a class="shouxing" @click="setYZ">短信验证码登录</a>
                    <a>没有账号?<span class="shouxing">立即注册</span></a>
                </el-form-item>
            </el-form>
        </div>
        <div class="xia" :style="objstyle1">
            <el-row :gutter="0" >
                <el-col :sm="20" :md="12" :lg="12" :offset="10">
                    <el-row :gutter="20" v-if="show">
                        <el-col :md="10" class="zuo">
                            <div class="downcode">
                                <!--<img :src="QRImgUrl">-->
                                <qrcodes title="App下载" :url="downcode.url" :iconurl="downcode.logo" v-show="!showCode"
                                         :wid="downcode.codeSize" :hei="downcode.codeSize"
                                        :imgwid="downcode.logoSize" :imghei="downcode.logoSize"></qrcodes>
                            </div>
                            <div class="qrcode" v-show="showCode">
                                <img v-show="false" src="jsynew.png" alt="" ref="logoImg">
                                <div class="qrcodeCanvas">
                                    <canvas ref="qrcodeCanvas"></canvas>
                                </div>
                                <!--<a href="javascript:;" class="button button-primary" @click="downloadCode">保存二维码</a>-->
                            </div>
                        </el-col>
                        <el-col :md="14" class="you">
                            <span>电话：0951-6993333  13909505698</span>
                            <span>地址：宁夏高新技术创业服务中心（A区）国家级科技企业孵化器</span>
                            <span>工业和信息化部备案管理系统网站  冀ICP备13019391号-1</span>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
        </div>
        <el-dialog
                title="忘记密码"
                :visible.sync="forgetdialogVisible"
                :close-on-click-modal="false"
                :close-on-press-escape="false"
                :destroy-on-close="true"
                width="30%"
                @close="handleClosePwd">
            <!--内容主体区域-->
            <el-form :model="forgetForm" :rules="forgetFormRules" ref="forgetFormRef" label-width="120px">
                <el-row>
                    <el-col :span="20">
                        <el-form-item label="手机号：" prop="mobile">
                            <el-input v-model="forgetForm.mobile"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="14">
                        <el-form-item label="验证码：" prop="code">
                            <el-input v-model="forgetForm.code"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="3" :offset="1">
                        <el-button type="primary" @click="getCode('forget')" :disabled="this.yanzheng.yzmSeconds<60">{{ yanzheng.yzmButtonText }}</el-button>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="20">
                        <el-form-item label="新密码：" prop="password">
                            <el-input type="password" v-model="forgetForm.password"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="20">
                        <el-form-item label="确认密码：" prop="againPassword">
                            <el-input type="password" v-model="forgetForm.againPassword"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="submitForm">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    // 按需导入API接口
    // import { getMenu } from '@/api/user'
    // http://admin.zhuineng.com:8091
    let webbaseurl=window.location.origin
    import {sendMsg} from '@/api/sms'
    import {forget} from '@/api/loginAPI'
    import {checkMobileUse, isPassword, validateCode} from '@/utils/rule'
    //import qrcodes from 'vue_qrcodes'
    import QRCode from 'qrcode'
    export default {
        name: '',
        //components:{qrcodes},
        data () {
            return {
                // 登录表单数据绑定对象 root999
                loginForm: {
                    userName: '',
                    password: '',
                    type: 'username',
                    mobile:'',
                    code:'',
                    // 是否选中记住登录密码
                    checked: false,
                },
                // 表单验证规则对象
                loginFormRules: {
                    userName: [
                        { required: true, message: '请输入用户名', trigger: 'blur' },
                        { validator: validateCode, trigger: 'blur' }
                    ],
                    password: [
                        { required: true, message: '请输入密码', trigger: 'blur' },
                        { validator: isPassword, trigger: 'blur' }
                    ],
                    mobile:[
                        { required: true, message: '请输入手机号', trigger: 'blur' },
                        { validator: checkMobileUse, trigger: 'blur' }
                    ],
                    code:[
                        { required: true, message: '请输入验证码', trigger: 'blur' }
                    ]
                },
                tubiao: [{ name: '智慧客厅', icon: 'keting' },
                    { name: '智慧卧室', icon: 'woshi' },
                    { name: '智慧厨房', icon: 'chufang' },
                    { name: '智慧卫生间', icon: 'weishengjian' },
                    { name: '智慧儿童房', icon: 'ertongfang' },
                    { name: '智慧老人房', icon: 'laorenfang' }
                ],
                eyecolor: '',
                passwordVisible: 'password',
                loading: false,
                forgetForm: {
                    mobile:'',
                    code: '',
                    password: '',
                    againPassword: ''
                },
                forgetdialogVisible: false,
                yanzheng: {
                    yzmSeconds: 60,
                    yzmButtonText: '获取验证码',
                    isSendYzm: false,
                    sendTimes: 0
                },
                objstyle: {

                },
                objstyle1: {

                },
                loginstyle:{},
                loginFormStyle:{},
                container:{},
                show:true,
                leftshow:true,
                //QRImgUrl:'',
                downcode: {
                    logo: 'jsynew.png',
                    url: webbaseurl+'/dist/appdownload.html',
                    codeSize:104,
                    logoSize:20
                },
                showCode:false,
                link:webbaseurl+'/dist/appdownload.html'
            }
        },
        methods: {
            resetLoginForm () {
                this.$refs.loginFormRef.resetFields()
            },
            login () {
                let that=this
                this.$refs.loginFormRef.validate(async valid => {
                    if (!valid) return
                    this.loading = true
                    //console.log('登录提交信息',this.loginForm)
                    // this.$store.dispatch('user/getInfo')
                    console.log('是否记住密码',this.loginForm.checked)
                    let data={}
                    if(this.loginForm.type==='username'){
                        data.type='username'
                        data.userName= this.loginForm.userName
                        data.password=this.loginForm.password
                    }else if(this.loginForm.type==='code'){
                        data.type='code'
                        data.mobile= this.loginForm.mobile
                        data.code=this.loginForm.code
                    }else if(this.loginForm.type==='mobile'){
                        data.type='mobile'
                        data.mobile= this.loginForm.mobile
                        data.password=this.loginForm.password
                    }
                    data.checked=this.loginForm.checked
                    this.$store.dispatch('user/login',data).then(() => {
                        // console.log('准备执行/index,获取是否有跳转地址',this.$route.query.redirect)
                        that.$router.push({
                            path:'/index',
                            query: {
                                name: this.$route.query.name,
                                label: this.$route.query.label
                            }
                        })
                        that.loading = false
                    }).catch(err => {
                        that.loading = false
                        console.log(err)
                    })
                })
            },
            showhide () {
                if(this.eyecolor=="#FF7800") {
                    this.eyecolor="#c0c4cc";
                    this.passwordVisible="password";
                } else {
                    this.eyecolor="#FF7800";
                    this.passwordVisible="text";
                }
            },
            getCode(type) {
                console.log('手机号',type,this.forgetForm.mobile,this.loginForm.mobile)
                if(type==='forget'&&(this.forgetForm.mobile===''||this.forgetForm.mobile===undefined)) return this.$message.error('请输入手机号')
                if(type==='login'&&(this.loginForm.mobile===''||this.loginForm.mobile===undefined)) return this.$message.error('请输入手机号')
                let postdata={}
                if(type==='forget'){
                    postdata.mobile=this.forgetForm.mobile
                }
                if(type==='login'){
                    postdata.mobile=this.loginForm.mobile
                }
                // 这里需要给手机号发送验证码，接口待对接
                sendMsg(postdata).then(response => {
                    console.log('发送验证码',response)
                    if (response.code != 200)
                        return this.$message.error(response.msg)
                    this.yanzheng.isSendYzm = true
                    let clock = window.setInterval(() => {
                        this.yanzheng.yzmSeconds--
                        this.yanzheng.yzmButtonText = '已发送（' + this.yanzheng.yzmSeconds + '）'
                        if (this.yanzheng.yzmSeconds < 1) {
                            window.clearInterval(clock)
                            this.yanzheng.yzmSeconds = 60
                            this.yanzheng.isSendYzm = false
                            this.yanzheng.yzmButtonText = '再次发送'
                            if (++this.yanzheng.sendTimes > 2) {
                                this.yanzheng.yzmButtonText = '发送次数已达到3'
                                this.yanzheng.isSendYzm = true
                                this.yanzheng.yzmSeconds = 0
                            }
                        }
                    }, 1000)
                    return
                })
            },
            submitForm(){
                this.$refs.forgetFormRef.validate(async valid => {
                    if (!valid) return
                    forget(this.forgetForm).then(response => {
                        console.log('忘记密码', response)
                        if (response.code != 200)
                            return this.$message.error(response.msg)
                        this.forgetdialogVisible = false
                        this.$message.success(response.msg)
                    })
                })
            },
            handleClosePwd() {
                this.$refs.forgetFormRef.resetFields()
                this.forgetdialogVisible = false
            },
            samePwd(rule, value, cb) {
                if(this.forgetForm.password === this.forgetForm.againPassword){
                    return cb()
                }
                return cb(new Error('新密码2次输入要一致'))
            },
            setUsername(){
                this.$refs.loginFormRef.resetFields()
                this.loginForm.userName=''
                this.loginForm.password=''
                this.loginForm.type='username'
                //console.log('账号',this.loginForm,this.loginFormRules)
            },
            setMobile(){
                this.$refs.loginFormRef.resetFields()
                this.loginForm.mobile=''
                this.loginForm.password=''
                this.loginForm.type='mobile'
                //console.log('手机',this.loginForm,this.loginFormRules)
            },
            setYZ(){
                this.$refs.loginFormRef.resetFields()
                this.loginForm.mobile=''
                this.loginForm.code=''
                this.loginForm.type='code'
                //console.log('验证',this.loginForm,this.loginFormRules)
            },
            getHeight(){
                this.container.height='100%'
                this.objstyle.height = window.innerHeight*0.66 + 'px'
                //this.objstyle1.height = window.innerHeight*0.34 + 'px'
                if(window.innerWidth*0.39+938<=window.innerWidth){
                    this.leftshow=true
                    this.loginstyle.width=938 + 'px'
                    this.loginFormStyle.left='57%'
                    this.loginFormStyle.width='40%'
                }else{
                    this.leftshow=false
                    this.loginstyle.width=938*0.45 + 'px'
                    this.loginFormStyle.left='5%'
                    this.loginFormStyle.width='90%'
                }
                //console.log(this.objstyle,this.objstyle1)
                if(window.innerHeight*0.34<280||window.innerWidth*0.39+938>window.innerWidth){
                    //console.log('隐藏')
                    this.show=false
                }else{
                    this.show=true
                }
            },
            imgToggleCanvas(){
                const canvas = document.createElement('canvas')
                const { logoImg } = this.$refs
                const ctx = canvas.getContext('2d')
                ctx.fillStyle = '#FFFFFF';
                ctx.fillRect(0, 0, 20, 20)
                //先画一个40*40的正方形，颜色#ffffff，此处因为logo图片四周没有留白
                ctx.drawImage(logoImg, 0, 0, 20, 20)
                //将 32*32 的 logoImg 画到 canvas 上
                return canvas
            },
            mergeCanvas(generateCanvas){
                //生成的二维码 canvas
                const { qrcodeCanvas } = this.$refs
                const logoCavans = this.imgToggleCanvas()
                //第2步里面的转换后的canvas
                const canvas = document.createElement('canvas')
                canvas.width = generateCanvas.width
                canvas.height = generateCanvas.height
                canvas.getContext('2d').drawImage(generateCanvas, 0, 0)
                //将 generateCanvas 画到 canvas 上，坐标 0，0
                canvas.getContext('2d').drawImage(logoCavans, 42, 42)
                //将 logoCavans 画到 canvas 上，坐标 80，80
                qrcodeCanvas.width = canvas.width
                qrcodeCanvas.height = canvas.height
                qrcodeCanvas.getContext('2d').drawImage(canvas, 0, 0)
            },
            // 生成二维码
            generateQrcode(){
                const options = {width: 104,height: 104,margin:1}
                QRCode.toCanvas(this.link,options).then((el) => {
                    this.showCode = true
                    //showCode 决定是否显示二维码
                    this.mergeCanvas(el)
                    //生成二维码后，合并二维码
                }).catch((err) => {
                    console.log(err)
                    this.showCode = false
                });
            }
        },
        computed: {
            forgetFormRules: function(){
                let arr= {}
                arr.mobile = [
                    { required: true, message: '请输入手机号', trigger: 'blur' }
                ],
                arr.code = [
                    { required: true, message: '请输入验证码', trigger: 'blur' }
                ],
                arr.password = [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    //{ validator: samePwd, trigger: 'blur' }
                ],
                arr.againPassword = [
                    { required: true, message: '请再次输入密码', trigger: 'blur' },
                    { validator: this.samePwd, trigger: 'blur' }
                ]
                return arr
            }
        },
        created(){
            if(localStorage.getItem('token')!=undefined&&localStorage.getItem('token')!=null) {
                this.loginForm.checked=true
            }
            this.getHeight()
            let that=this
            window.setTimeout(function() {
                that.generateQrcode();
            }, 200);
            window.addEventListener('resize', this.getHeight)
        }
    }
</script>

<style lang="scss" scoped="scoped">
    .raise:hover {
        margin-top: -20px;
    }
    .login_container {
        background-color: #FFDA4B;
        height: 100%;
    }
    .shang{
        background-color: #000000;
        height: 66%;
        img:first-child{
            position: absolute;
            top: 5px;
            left: 15px;
            width: 35%;
            opacity: 0.4;
        }
        img:last-child{
            position: absolute;
            /*top: -30%;*/
            /* right: 0px;*/
            height: 52%;
        }
    }
    .shang .you{
        background-image: url(../assets/login/未标题-1.png);
        background-repeat: no-repeat;
        width: 600px;
        height: 300px;
        background-position: -210px -420px;
        float: right;
    }
    .login_box{
        width: 938px;
        height: 387px;
        background-color: #fff;
        border-radius: 10px;
        position: absolute;
        left: 39%;
        top: 30%;
        padding: 20px;
        .title{
            position: absolute;
            top: -62px;
            left: 60px;
        }
        .left{
            width: 55%;
            height: 100%;
            text-align: center;
            /* padding: 20px;*/
            #hot-title {
                position: absolute;
                top: 87px;
                left: 52px;
                font-size: 6px;
            }
            #hot-line {
                position: absolute;
                top: 91px;
                left: 130px;
            }
            #hot {
                position: absolute;
                top: 110px;
                left: 190px;
            }
            #water-title {
                position: absolute;
                top: 210px;
                left: 32px;
                font-size: 6px;
            }
            #water-line {
                position: absolute;
                top: 205px;
                left: 122px
            }
            #water {
                position: absolute;
                top: 180px;
                left: 245px;
            }
            #wind-title {
                position: absolute;
                top: 65px;
                left: 450px;
                font-size: 6px;
            }
            #wind-line {
                position: absolute;
                top: 70px;
                left: 318px;
            }
            #wind {
                position: absolute;
                top: 50px;
                left: 275px;
            }
            #ai-title {
                position: absolute;
                top: 212px;
                left: 425px;
                font-size: 6px;
            }
            #ai-line {
                position: absolute;
                top: 152px;
                left: 363px;
            }
            #ai {
                position: absolute;
                top: 110px;
                left: 335px;
            }
        }
        .denglu{
            background-color: #E7BC13;
            width: 100%;
            height: 48px;
            border: none;
            color: white;
            font-size: 21px;
        }
        .btns ::v-deep {
            .el-form-item__content {
                margin-left: 0px !important;
                text-align: center;
                margin-top: 30px;
                margin-bottom: 30px;
            }
        }
        .el-form-item {
            margin-bottom: 0px;
        }
        .el-form-item__content{
            line-height: 60px;
        }
    }
    .login_form {
        position: absolute;
        bottom: 0;
        left: 57%;
        width: 40%;
        height: 100%;
        padding: 20px 0px;
        box-sizing: border-box;
        z-index: 3000;
    }
    .bottomline{
        border-bottom: 1px solid #ECEBEB;
        margin-bottom: 16px!important;
    }
    .bottomline ::v-deep {
        .el-input__inner {
            border: 0;
            line-height: 40px;
            height: 40px;
        }
        .el-form-item__label{
            line-height: 40px;
            color: #666666;
        }
        .el-form-item__error{
            margin-left: 15px;
        }
    }
    .textfont ::v-deep {
        .el-form-item__label{
            width: 100px!important;
            font-size: 20px;
            line-height: 60px;
            color: #E7BC13;
        }
    }
    .mima ::v-deep {
        .el-form-item__content{
            margin-left: 0px!important;
        }
        .el-checkbox__label{
            color: #999999;
        }
        color: #999999;
    }
    .mima a{
        float: right;
    }
    .zhuce ::v-deep {
        .el-form-item__content {
            margin-left: 0px !important;
            color: #999999;
        }
    }
    .zhuce a:first-child{
        float: left;
    }
    .zhuce a:last-child{
        float: right;
    }
    .zhuce span{
        color: #00C4E0;
    }
    .left span{
        font-size: 10px;
        line-height: 13px;
        color: #1F2431;
    }
    .login_box img{
        font-size: 40px;
        color: #E7BC13;
    }
    .left-bot{
        height: 20%;
    }
    .login_box .title img{
        /* color: white;
        font-family: cursive; */
        font-size: 40px;
    }
    .xia{
        /*height: 34%;
        padding: 0px;
        min-height: 200px;*/
        position: absolute;
        bottom: 50px;
        width: 100%;
    }
    .xia .iconfont{
        font-size: 80px;
        /* color: #E7BC13; */
    }
    .xia span{
        color: #333333;
        display: block;
        margin-bottom: 17px;
    }
    .xia .you span:last-child{
        color: #81733C;
    }
    .shouxing{
        cursor: pointer;
    }
    .downcode .qrcode{
        padding: 4px;
        background-color: #fff;
    }
</style>
